// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__2ytG0","Icon":"Languages_Icon__S4EYp","LanguagesSelect":"Languages_LanguagesSelect__2Cyxd","minimalist":"Languages_minimalist__1cbSV"};